/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

export interface ObstacleAvoidanceEnum {
}

export enum ObstacleAvoidanceEnum_Enum {
  UNSPECIFIED = 0,
  /** DEFAULT - Default obstacle avoidance */
  DEFAULT = 1,
  /** REDUCED - Reduced obstacle avoidance */
  REDUCED = 2,
  /** MINIMAL - Minimal obstacle avoidance */
  MINIMAL = 3,
  /** DISABLED - Disabled obstacle avoidance */
  DISABLED = 4,
  UNRECOGNIZED = -1,
}

export function obstacleAvoidanceEnum_EnumFromJSON(object: any): ObstacleAvoidanceEnum_Enum {
  switch (object) {
    case 0:
    case "UNSPECIFIED":
      return ObstacleAvoidanceEnum_Enum.UNSPECIFIED;
    case 1:
    case "DEFAULT":
      return ObstacleAvoidanceEnum_Enum.DEFAULT;
    case 2:
    case "REDUCED":
      return ObstacleAvoidanceEnum_Enum.REDUCED;
    case 3:
    case "MINIMAL":
      return ObstacleAvoidanceEnum_Enum.MINIMAL;
    case 4:
    case "DISABLED":
      return ObstacleAvoidanceEnum_Enum.DISABLED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ObstacleAvoidanceEnum_Enum.UNRECOGNIZED;
  }
}

export function obstacleAvoidanceEnum_EnumToJSON(object: ObstacleAvoidanceEnum_Enum): string {
  switch (object) {
    case ObstacleAvoidanceEnum_Enum.UNSPECIFIED:
      return "UNSPECIFIED";
    case ObstacleAvoidanceEnum_Enum.DEFAULT:
      return "DEFAULT";
    case ObstacleAvoidanceEnum_Enum.REDUCED:
      return "REDUCED";
    case ObstacleAvoidanceEnum_Enum.MINIMAL:
      return "MINIMAL";
    case ObstacleAvoidanceEnum_Enum.DISABLED:
      return "DISABLED";
    case ObstacleAvoidanceEnum_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseObstacleAvoidanceEnum(): ObstacleAvoidanceEnum {
  return {};
}

export const ObstacleAvoidanceEnum = {
  encode(_: ObstacleAvoidanceEnum, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ObstacleAvoidanceEnum {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseObstacleAvoidanceEnum();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ObstacleAvoidanceEnum {
    return {};
  },

  toJSON(_: ObstacleAvoidanceEnum): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ObstacleAvoidanceEnum>, I>>(base?: I): ObstacleAvoidanceEnum {
    return ObstacleAvoidanceEnum.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ObstacleAvoidanceEnum>, I>>(_: I): ObstacleAvoidanceEnum {
    const message = createBaseObstacleAvoidanceEnum();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
